import type { Listing } from '@thevillages/schemas';

import { Component, input, output } from '@angular/core';

import { ContactForm } from '../../contact-form/contact-form';
import { ListingDetailsSidebarRep } from './rep/rep';
import { ListingDetailsSidebarSellCta } from './sell-cta/sell-cta';

@Component({
  imports: [ContactForm, ListingDetailsSidebarRep, ListingDetailsSidebarSellCta],
  selector: 'app-listing-details-sidebar',
  styleUrl: './sidebar.css',
  templateUrl: './sidebar.html',
})
export class ListingDetailsSidebar {
  public readonly listing = input.required<Listing>();
  public readonly setRepFilter = output<string>();
}
